import { IClientCityBrief } from '@bustickus/models-client';
import { useEffect, useState } from 'react';
import { Flex } from 'components';
import { ApiCities } from 'common/api';
import { ModalLoader, PageSidebar } from 'shared/components';
import { FilterBlock, TripBlock } from './components';
import { handleErrorAsync } from 'common/handlers';
import { useSearchParams } from 'react-router';
import { TripsPageQueryParam } from 'common/navigation';
import { dateOnlyParse } from 'common/helpers';

function PageTrips() {
  const [cities, setCities] = useState<IClientCityBrief[] | null>(null);
  const [searchParams] = useSearchParams();

  const [searchDepartureCityId, setSearchDepartureCityId] = useState<string | null>(null);
  const [searchArrivalCityId, setSearchArrivalCityId] = useState<string | null>(null);
  const [searchDepartureDate, setSearchDepartureDate] = useState<Date | null>(null);
  const [searchReturnDate, setSearchReturnDate] = useState<Date | null>(null);

  useEffect(() => {
    setSearchDepartureCityId(getSearchParam('from'));
    setSearchArrivalCityId(getSearchParam('to'));

    const departureDateParsed = dateOnlyParse(getSearchParam('date'));
    const returnDateParsed = dateOnlyParse(getSearchParam('back'));

    if (departureDateParsed != null) {
      setSearchDepartureDate(
        new Date(departureDateParsed.year, departureDateParsed.month - 1, departureDateParsed.day)
      );
    }

    if (returnDateParsed != null) {
      setSearchReturnDate(new Date(returnDateParsed.year, returnDateParsed.month - 1, returnDateParsed.day));
    }
  }, []);

  const getSearchParam = (param: TripsPageQueryParam): string | null => {
    return searchParams.get(param);
  };

  useEffect(() => {
    loadCities();
  }, []);

  const loadCities = async () =>
    await handleErrorAsync(async () => {
      const cities = await ApiCities.getInstance().getAll();
      setCities(cities);
    });

  const handleSearchClick = async (
    departureCityId: string,
    arrivalCityId: string,
    departureDate: Date,
    returnDate: Date | undefined | null
  ) => {
    setSearchDepartureCityId(departureCityId);
    setSearchArrivalCityId(arrivalCityId);
    setSearchDepartureDate(departureDate);
    setSearchReturnDate(returnDate ?? null);
  };

  return (
    <PageSidebar
      title='Рейсы'
      frameTitle='Поиск рейсов'
    >
      {cities == null && <ModalLoader />}

      {cities != null && (
        <Flex
          direction='column'
          gap={20}
        >
          <FilterBlock
            departureCityId={searchDepartureCityId}
            arrivalCityId={searchArrivalCityId}
            departureDate={searchDepartureDate}
            returnDate={searchReturnDate}
            cities={cities}
            onSearchClick={handleSearchClick}
          />

          <TripBlock
            departureCityId={searchDepartureCityId}
            arrivalCityId={searchArrivalCityId}
            departureDate={searchDepartureDate}
            returnDate={searchReturnDate}
          />
        </Flex>
      )}
    </PageSidebar>
  );
}

export default PageTrips;
